import { render, staticRenderFns } from "./contactUsItem.vue?vue&type=template&id=6509a56c&scoped=true&"
import script from "./contactUsItem.vue?vue&type=script&lang=js&"
export * from "./contactUsItem.vue?vue&type=script&lang=js&"
import style0 from "./contactUsItem.vue?vue&type=style&index=0&id=6509a56c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6509a56c",
  null
  
)

export default component.exports